module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVBAMAAACAghKHAAAAGFBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZl5tJwoAAAAB3RSTlMAnZ6R9YXbe6wmHAAAADNJREFUCNdjCDFgAAH3IjBlXq4AohjLIVxx4rjFYG56CZQHkRMAcwrxc8zBHAZ3MAfqFgCn5xAUD3RW0AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-next.png
// module id = sUXE
// module chunks = 21